module.exports = __webpack_public_path__ + "img/icon-heart-orange.ba8b2b2f.svg";